const setObjectProperty = (object, parts, value) => {
    const limit = parts.length - 1;
    for (let i = 0; i < limit; ++i) {
        const key = parts[i];
        object = object[key] ?? (object[key] = { });
    }
    const key = parts[limit];
    object[key] = value;
};

export default {
    methods: {
        buildFormParams(formId, truePaths = false, omitIds = true) {
            let obj = {};
            let elements = document.getElementById(formId).querySelectorAll( "input, select, textarea" );
            let addressFinal = [];
            addressFinal[0] = {};

            for( let i = 0; i < elements.length; ++i ) {
                let element = elements[i];
                let name = element.name;
                let value = element.value;
                let type = element.type;

                if (truePaths) {
                    let path = name.replace(/[\[|\]]/g, ".").split('.').filter(item => item);
                    if (omitIds && (path[path.length - 1] === 'id')) {
                        continue;
                    }
                    if (type === 'checkbox') {
                        setObjectProperty(obj, path, element.checked ? 'on' : 'off');
                    } else if ((element.type !== 'radio') || (element.type === 'radio' && element.checked)) {
                        setObjectProperty(obj, path, value);
                    }
                } else {
                    if (name && type !== 'radio' && type !== 'checkbox' && !name.includes('addresses[0]')) {
                        obj[name] = value;
                    } else if(type === 'checkbox') {
                        obj[name] = element.checked ? 'on' : 'off';
                    }
                    else if(name.includes('addresses[0]')) {
                        let addressFields = ['address', 'address2', 'city', 'state', 'zip'];

                        addressFields.forEach( (field) => {
                            if( name.includes("[" + field + "]")) {
                                addressFinal[0][field] = value;
                            }
                        });
                        obj['addresses'] = addressFinal;
                    } else if (element.type === 'radio' && element.checked) {
                        obj[name] = value;
                    }
                }
            }

            return obj;
        }
    }
}